import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    padding: "sm",
    rounded: "",
    flat: _ctx.outline,
    color: _ctx.color,
    "no-caps": "",
    disable: _ctx.disable,
    class: _normalizeClass([{ 's-button-outline': _ctx.outline }, "text-weight-bold"])
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$filters.sentenceCase(_ctx.label)), 1)
    ]),
    _: 1
  }, 8, ["flat", "color", "disable", "class"]))
}